import { useState, useEffect } from 'react';

const navItems = [
  { label: 'Projetos', href: '#projetos' },
  { label: 'A arquiteta', href: '#arquiteta' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Processo', href: '#processo' },
  { label: 'Experiências', href: '#experiencias' },
  { label: 'Contato', href: '#contato' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.querySelector(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-editorial ${
        scrolled
          ? 'bg-white/95 backdrop-blur-[12px] shadow-[0_1px_0_0_rgba(0,0,0,0.05)]'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-16 md:h-20 px-6 md:px-12 lg:px-20">
        {/* Logo */}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="flex items-center"
        >
          <img
            src="https://storage.readdy-site.link/project_files/984fb076-7af4-4ebe-bc63-07e20452888b/0a9ff90d-afe9-4bcc-baa6-21d12203b4d5_LOGO-MARCA-D_GUA.png?v=5a326700360f55983d50a6f422058b16"
            alt="Stephanie Zarowny"
            className="h-8 md:h-9 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={(e) => scrollTo(e, item.href)}
              className="font-body text-sm font-light text-black hover:text-marrom transition-colors duration-300 whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* CTA + Mobile Toggle */}
        <div className="flex items-center gap-4">
          <a
            href="#contato"
            onClick={(e) => scrollTo(e, '#contato')}
            className="hidden sm:inline-flex items-center justify-center px-5 py-2.5 text-sm font-light text-white bg-marrom rounded-full hover:bg-cinza-marca transition-colors duration-300 whitespace-nowrap"
          >
            Entre em contato
          </a>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden flex flex-col items-center justify-center w-10 h-10 gap-1.5"
            aria-label="Menu"
          >
            <span
              className={`block h-px w-6 bg-black transition-all duration-300 ${
                mobileOpen ? 'rotate-45 translate-y-[3.5px]' : ''
              }`}
            />
            <span
              className={`block h-px w-6 bg-black transition-all duration-300 ${
                mobileOpen ? '-rotate-45 -translate-y-[3.5px]' : ''
              }`}
            />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden bg-white border-t border-black/5 overflow-hidden transition-all duration-500 ease-editorial ${
          mobileOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 py-6 flex flex-col gap-4">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={(e) => scrollTo(e, item.href)}
              className="font-body text-base font-light text-black hover:text-marrom transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contato"
            onClick={(e) => scrollTo(e, '#contato')}
            className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-light text-white bg-marrom rounded-full hover:bg-cinza-marca transition-colors duration-300 mt-2"
          >
            Entre em contato
          </a>
        </div>
      </div>
    </header>
  );
}